// No-op migration due to a revert PROD-56726
// You can't just delete migrations. If someone else added another v38,
// those websites already migrated would not run that new v38
export default function v38(website) {
  return {
    ...website,
    eventVersion: 38
  };
}
